export enum RwGType {
  /** 美類 */
  Appointments = 0,
  /** TableApp / Dining */
  Dining = 1,
}

export const PARTNER_ID_MAP: Record<RwGType, string> = {
  [RwGType.Appointments]: '20000498',
  [RwGType.Dining]: '20000432',
}
